import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import "./ProductView.css";

function ProductView() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [product, setProduct] = useState(null);
  const [mainImage, setMainImage] = useState(null);
  const [toast, setToast] = useState({ open: false, message: "", severity: "success" });
  const [cartItems, setCartItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const showToast = (message, severity = "success") => setToast({ open: true, message, severity });
  // Fetch product by ID
  useEffect(() => {
    fetch(`https://citrine-backend-0hws.onrender.com/api/products/${id}`)
      .then((res) => res.json())
      .then((data) => {
        const productData = Array.isArray(data) ? data[0] : data;
        setProduct(productData);
        setMainImage(productData.product_image || productData.product_image2 || productData.product_image3 || productData.product_image4 || productData.product_image5);
   
      })
      .catch((err) => console.error(err));
  }, [id]);

  // Fetch cart
  const fetchCart = async () => {
    const token = localStorage.getItem("token");
    if (!token) return;
    setLoading(true);
    try {
      const res = await fetch("https://citrine-backend-0hws.onrender.com/api/cart", { headers: { Authorization: token } });
      const data = await res.json();
      setCartItems(data);
    } catch (err) {
      console.error(err);
    }finally {
    setLoading(false);
  }
  };
  useEffect(() => { fetchCart(); }, []);

 const addToCart = async (product_id) => {
    const token = localStorage.getItem("token");

    if (!token) {
      showToast("Please login first", "warning");
      setTimeout(() => navigate("/login"), 1000);
      return;
    }

    const alreadyExists = cartItems.some(
      (item) => Number(item.product_id) === Number(product.product_id)
    );

    if (alreadyExists) {
      showToast("Already in cart", "info");
      setTimeout(() => navigate("/cart"), 1000);
      return;
    }

    setLoading(true);
    try {
      await fetch("https://citrine-backend-0hws.onrender.com/api/cart", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization:  `Bearer ${token}`
        },
        body: JSON.stringify({ product_id })
      });

      fetchCart();
      showToast("Added to cart 🛒", "success");

      window.dispatchEvent(new Event("cartUpdated"));
    } catch (err) {
      console.error(err);
      showToast("Error adding product", "error");
    }finally {
    setLoading(false);
  }
  };


  // if (!product) return <p>Loading...</p>;
  if (!product) return (<div className="product-container">
    <div className="product-wrapper">
      {/* Skeleton for image */}
      <div className="image-gallery">
        <div className="skeleton skeleton-image"></div>
        <div className="thumbnail-wrapper">
          {[...Array(4)].map((_, idx) => (
            <div key={idx} className="skeleton skeleton-thumbnail"></div>
          ))}
        </div>
      </div>

      {/* Skeleton for details */}
      <div className="product-details">
        <div className="skeleton skeleton-title"></div>
        <div className="skeleton skeleton-category"></div>
        <div className="skeleton skeleton-price"></div>
        <div className="skeleton skeleton-button"></div>
      </div>
    </div>
  </div>);

  const inCart = cartItems.some(item => Number(item.product_id) === Number(product.product_id));
  // const images = [product.product_image, product.product_image2, product.product_image3, product.product_image4, product.product_image5].filter(Boolean);
const images = [
  product.product_image,
  product.product_image2,
  product.product_image3,
  product.product_image4,
  product.product_image5
]
  .filter(Boolean)
  .map(img => `${img}`);
  return (
    <div className="product-container">
      
      <div className="product-wrapper">
        {/* Image gallery */}
        <div className="image-gallery">
          <img src={mainImage} alt={product.product_name} className="main-image" />
          <div className="thumbnail-wrapper">
            {images.map((img, idx) => (
              <img
                key={idx}
                src={img}
                alt={`Thumbnail ${idx + 1}`}
                style={{
                  ...styles.thumbnail,
                  border: img === mainImage ? "2px solid #007bff" : "1px solid #ddd"
                }}
                onClick={() => setMainImage(img)}
              />
            ))}
          </div>
        </div>

        {/* Product details */}
        <div className="product-details">
          <h1 style={styles.productName}>{product.product_name}</h1>
          <p className="category">Category: {product.category}</p>
          <p className="price">₹ {product.product_price}</p>
          <button className="add-to-cart"
            onClick={() => (inCart ? navigate("/cart") : addToCart(product.product_id))}
            style={{ ...styles.button, backgroundColor: inCart ? "#28a745" : "#007bff" }}
          >
            {inCart ? "Go to Cart" : "Add to Cart"}
          </button>
        </div>
      </div>

      {/* Toast */}
      <Snackbar
        open={toast.open}
        autoHideDuration={2000}
        onClose={() => setToast({ ...toast, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert severity={toast.severity} variant="filled">{toast.message}</Alert>
      </Snackbar>
    </div>
  );
}

// Modern responsive styles
const styles = {
  container: {
    padding: "20px",
    margin: "150px",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
  },
  productWrapper: {
    display: "flex",
    gap: "50px",
    flexWrap: "wrap",
    justifyContent: "center"
  },
  imageGallery: {
    flex: "1",
    minWidth: "300px",
    maxWidth: "450px"
  },
  mainImage: {
    width: "100%",
    borderRadius: "8px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    marginBottom: "15px"
  },
  thumbnailWrapper: {
    display: "flex",
    gap: "10px",
    flexWrap: "wrap"
  },
  thumbnail: {
    width: "60px",
    height: "60px",
    objectFit: "cover",
    borderRadius: "4px",
    cursor: "pointer",
    transition: "transform 0.2s",
  },
  details: {
    flex: "1",
    minWidth: "250px",
    maxWidth: "500px"
  },
  productName: {
    fontSize: "26px",
    marginBottom: "10px"
  },
  category: { fontSize: "16px", color: "#555", marginBottom: "15px" },
  price: { fontSize: "24px", fontWeight: "bold", marginBottom: "20px", color: "#111" },
  button: {
    padding: "12px 25px",
    border: "none",
    borderRadius: "8px",
    color: "#fff",
    cursor: "pointer",
    fontSize: "16px",
    transition: "background-color 0.3s",
  },
  // Mobile responsiveness
  '@media (max-width: 768px)': {
    productWrapper: {
      flexDirection: "column",
      alignItems: "center",
    },
    imageGallery: {
      maxWidth: "90%",
    },
    details: {
      maxWidth: "90%",
      textAlign: "center"
    }
  }
};

export default ProductView;